import { motion } from 'framer-motion'
import SectionHeader from './SectionHeader'
import { researchInterests } from '../data/researchInterests'

const ResearchInterests = () => {
  return (
    <section id="research" className="border-y border-academic-line bg-white/45 py-20 md:py-24">
      <div className="section-shell">
        <SectionHeader
          centered
          kicker="Research"
          title="Research interests with practical engineering direction."
          text="These themes connect my technical projects with graduate-level questions about intelligent systems, people, and usable software."
        />

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {researchInterests.map(({ title, description, icon: Icon }, index) => (
            <motion.article
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              className="card p-6 transition hover:-translate-y-1 hover:border-academic-blue"
            >
              <div className="inline-flex rounded-2xl bg-academic-soft p-3 text-academic-blue">
                <Icon size={22} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-academic-text">{title}</h3>
              <p className="mt-3 leading-7 text-academic-muted">{description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ResearchInterests
